export default __webpack_public_path__ + "static/media/accounts.d8575b6e.svg";